import { render, staticRenderFns } from "./CourseSendMessageModal.vue?vue&type=template&id=4286c1a3&scoped=true&"
import script from "./CourseSendMessageModal.vue?vue&type=script&lang=ts&"
export * from "./CourseSendMessageModal.vue?vue&type=script&lang=ts&"
import style0 from "./CourseSendMessageModal.vue?vue&type=style&index=0&id=4286c1a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4286c1a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VFileInput,VForm,VIcon,VRadio,VRadioGroup,VRow,VSelect,VTab,VTabs,VTextField,VTextarea})
